import FormSingleDropzone from '@form/FormSingleDropzone';
import { get } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { helperTextClassNames, labelClassNames } from '~/components/ui/Form/StyledInput';

interface FormularFileInputProps {
    name: string;
    label?: string;
    helperText?: string;
    acceptedFileTypes?: string;
}

const FormularFileInput = ({ name, label, helperText, acceptedFileTypes }: FormularFileInputProps) => {
    const {
        formState: { errors }
    } = useFormContext();
    const error = get(errors, name);
    const accept = acceptedFileTypes ? acceptedFileTypes.split(',').map((t) => t.trim()) : undefined;

    return (
        <div className="tw-my-1 tw-w-full">
            {label && <label className={labelClassNames({ isInvalid: !!error })}>{label}</label>}
            <FormSingleDropzone name={name} options={accept ? ({ accept } as any) : undefined} />
            {((error?.message as string) || helperText) && (
                <span className={helperTextClassNames({ isInvalid: !!error })}>
                    {(error?.message as string) || helperText}
                </span>
            )}
        </div>
    );
};

export default FormularFileInput;
